import { FormState } from "../../models";
import { basicInfo } from './basic-info';
import { dialogActions } from './dialog-actions';
import { GenericLocationCardState } from "./models";

export const genericFormState = (state: GenericLocationCardState): FormState => {
    return {
        config: {
            info: {
                id: 'generic-location-config',
                title: 'Generic Location Configuration',
            },
            sections: [
                basicInfo(state),
                dialogActions(state),
            ],
        },
    }
}
